export default __webpack_public_path__ + "static/media/user-profile.eca78138.svg";